module.exports = __webpack_public_path__ + "img/license.cbcdc951.jpg";